<div class="h-100 d-flex flex-column container">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-breadcrumbs></ziro-breadcrumbs>
    <ziro-migrations-create-form [allAssessments]="allAssessments"></ziro-migrations-create-form>
  }
</div>
